<lg-navbar-profile
  [userProfile]="userProfile()"
  [(open)]="isOpen"
  [displayNameMaxLength]="18"
>
  <nav class="tw-flex tw-flex-col" aria-label="Opciones del menú de usuario">
    <button
      *hasPermissions="'users'; for: ['view']"
      type="button"
      class="navbar-profile-item"
      (click)="navigateToOption('/priv/usuarios')"
    >
      <span
        class="tabler-mask-icon navbar-profile-item__icon"
        style="--tabler-icon: url('assets/img/tabler/users.svg')"
        aria-hidden="true"
      ></span>
      Usuarios
    </button>
    <button
      *hasPermissions="'users'; for: ['view']"
      type="button"
      class="navbar-profile-item"
      (click)="navigateToOption('/priv/usuarios/lista-abogados')"
    >
      <span
        class="tabler-mask-icon navbar-profile-item__icon"
        style="--tabler-icon: url('assets/img/tabler/gavel.svg')"
        aria-hidden="true"
      ></span>
      Abogados
    </button>
    <button
      *hasPermissions="'roles'; for: ['view']"
      type="button"
      class="navbar-profile-item"
      (click)="navigateToOption('/priv/roles')"
    >
      <span
        class="tabler-mask-icon navbar-profile-item__icon"
        style="--tabler-icon: url('assets/img/tabler/id-badge.svg')"
        aria-hidden="true"
      ></span>
      Roles
    </button>
    <button
      type="button"
      class="navbar-profile-item"
      (click)="navigateToOption('/priv/plantillas')"
    >
      <span
        class="tabler-mask-icon navbar-profile-item__icon"
        style="--tabler-icon: url('assets/img/tabler/file-text.svg')"
        aria-hidden="true"
      ></span>
      Mis plantillas
    </button>
    <button
      type="button"
      class="navbar-profile-item navbar-profile-item--logout"
      (click)="logOut()"
    >
      <span
        class="tabler-mask-icon navbar-profile-item__icon"
        style="--tabler-icon: url('assets/img/tabler/logout.svg')"
        aria-hidden="true"
      ></span>
      Cerrar sesión
    </button>
  </nav>
</lg-navbar-profile>
